(function () {
  document.querySelectorAll('[data-product-gallery]').forEach(function (gallery) {
    gallery.addEventListener('click', function (event) {
      var thumb = event.target.closest('[data-gallery-thumb]');
      if (!thumb) return;
      var id = thumb.getAttribute('data-gallery-thumb');
      gallery.querySelectorAll('[data-gallery-thumb]').forEach(function (node) {
        node.classList.toggle('is-active', node === thumb);
      });
      gallery.querySelectorAll('[data-media-id]').forEach(function (slide) {
        slide.classList.toggle('is-active', slide.getAttribute('data-media-id') === id);
      });
    });
  });
})();
